const r = (t) => {
  if (t.length === 0 || t.length > 4)
    return;
  const a = document.getElementById("dates-container");
  for (let e = 0; e < t.length; e++) {
    const l = t[e], o = document.getElementsByClassName(
      `available-${l.month}-${l.year}`
    );
    if (o.length > 0 && a) {
      const n = o[0];
      if (e === 0)
        break;
      a.scrollTo({
        top: (n.offsetTop + 30) / (e + 1),
        behavior: "smooth"
      });
      break;
    }
  }
};
export {
  r as scrollToFirstAvailableDay
};
